import React from 'react';
import { uniqueId } from 'lodash-es';
import { Box } from '@alf/uikit';
import { Icon } from '@namespace/icons2';
import {
  BULLETS_GOAL_SCOPE_ID,
  PENALTY_GOAL_SCOPE_ID
} from '../../../../constants';
import { ScoreObject } from '../../../../types';

type PenaltyProps = {
  scopeId: ScoreObject['scopeId'];
  className: string;
};

const Penalty = ({ scopeId, className }: PenaltyProps) => {
  return (
    <Box className={className} key={uniqueId('scoreCell_')}>
      {scopeId !== 0 && (
        <Icon
          size="xs"
          color={
            scopeId === PENALTY_GOAL_SCOPE_ID ||
            scopeId === BULLETS_GOAL_SCOPE_ID
              ? 'state_success'
              : 'state_error'
          }
          name={`icons/general/state/${
            scopeId === PENALTY_GOAL_SCOPE_ID ||
            scopeId === BULLETS_GOAL_SCOPE_ID
              ? 'success'
              : 'canceled'
          }`}
        />
      )}
    </Box>
  );
};

export default Penalty;
